import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { injectIntl, intlShape, FormattedMessage } from 'react-intl';
import { Row, Col } from 'reactstrap';

import { getCartShipping, getCartVoucher, getCartTotals } from '../../CartActions';
import { getTaxByCountry } from '../../../Tax/TaxActions';
import { getTranslation } from '../../../Intl/IntlActions';

import Price from '../../../Currency/components/view/Price';

function CartTotals({ intl, shipping, tax, voucher, cartTotals }) {
    return (
        <div className="text-uppercase text-dark alt-font">
            <Row>
                <Col xs="6" className="text-right">
                    <FormattedMessage id="cartTotalSubTotal" defaultMessage="Sub total" />
                </Col>
                <Col xs="6" md={{ size: 4, offset: 2 }}>
                    <Price amount={cartTotals.items} />
                </Col>
            </Row>
            {
                shipping && shipping.address && shipping.address.countryCode && cartTotals.shippingFee !== null && (
                    <Row>
                        <Col xs="6" className="text-right">
                            <FormattedMessage id="cartTotalShipping" defaultMessage="Shipping fee" />
                        </Col>
                        <Col xs="6" md={{ size: 4, offset: 2 }}>
                            {cartTotals.shippingFee > 0 ? <Price amount={cartTotals.shippingFee} /> : <FormattedMessage id="cartTotalShippingFree" defaultMessage="Free" />}
                        </Col>
                    </Row>
                )
            }
            {
                voucher && cartTotals.voucher > 0 && (
                    <Row className="text-success">
                        <Col xs="6" className="text-right">
                            {getTranslation(voucher, 'name', intl.locale)}
                        </Col>
                        <Col xs="6" md={{ size: 4, offset: 2 }}>
                            -<Price amount={cartTotals.voucher} />
                        </Col>
                    </Row>
                )
            }
            <Row>
                <Col xs="6" className="text-right">
                    <FormattedMessage id="cartTotalTax" defaultMessage="VAT" />
                </Col>
                <Col xs="6" md={{ size: 4, offset: 2 }}>
                    {cartTotals.tax !== null ? <Price amount={cartTotals.tax} /> : <span className="text-warning"><FormattedMessage id="cartTotalTaxNotSet" defaultMessage="Please choose your delivery country" /></span>}
                </Col>
            </Row>
            <Row className="font-weight-bold">
                <Col xs="6" className="text-right">
                    <FormattedMessage id="cartTotalTotal" defaultMessage="Total" />
                </Col>
                <Col xs="6" md={{ size: 4, offset: 2 }}>
                    <Price amount={cartTotals.totalTTC} />
                </Col>
            </Row>
        </div>
    );
}

function mapStateToProps(store, props) {
    const shipping = getCartShipping(store);
    const voucher = getCartVoucher(store);
    return {
        shipping,
        tax: getTaxByCountry(store, shipping && shipping.address && shipping.address.countryCode),
        voucher,
        cartTotals: getCartTotals(store),
    };
}

CartTotals.defaultProps = {
    shipping: null,
    tax: null,
    voucher: null,
    cartTotals: {},
};

CartTotals.propTypes = {
    intl: intlShape.isRequired,
    shipping: PropTypes.object,
    tax: PropTypes.object,
    voucher: PropTypes.object,
    cartTotals: PropTypes.object,
};

export default connect(mapStateToProps)(injectIntl(CartTotals));
